const STORAGE_KEY = "wildlark:fleet-sidebar:v1"

/**
 * Client-owned, fleet-wide sidebar preferences. Hiding a project removes its
 * row into the Hidden disclosure and its tasks from the blend on every
 * computer this client uses; it never touches the project record itself,
 * which is why it works for shared projects you do not own.
 */
export interface FleetSidebarState {
    hiddenProjectIds: string[]
    hiddenVisible: boolean
}

function parse(value: unknown): FleetSidebarState | null {
    if (typeof value !== "object" || value === null || Array.isArray(value)) return null
    const hidden = Reflect.get(value, "hiddenProjectIds")
    if (!Array.isArray(hidden) || hidden.some((item) => typeof item !== "string")) return null
    const hiddenVisible = Reflect.get(value, "hiddenVisible")
    return { hiddenProjectIds: [...new Set(hidden as string[])], hiddenVisible: hiddenVisible === true }
}

export function loadFleetSidebarState(storage: Pick<Storage, "getItem"> = window.localStorage): FleetSidebarState {
    try {
        const raw = storage.getItem(STORAGE_KEY)
        const parsed = raw ? parse(JSON.parse(raw)) : null
        return parsed ?? { hiddenProjectIds: [], hiddenVisible: false }
    } catch {
        return { hiddenProjectIds: [], hiddenVisible: false }
    }
}

export function saveFleetSidebarState(state: FleetSidebarState, storage: Pick<Storage, "setItem"> = window.localStorage): void {
    try {
        storage.setItem(STORAGE_KEY, JSON.stringify(state))
    } catch {
        // Sidebar preferences are best-effort when storage is unavailable.
    }
}
